/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import { SET_LINKS } from 'src/redux/actions/links';


const initialState = {};


const setLinks = (state, links) => ({
  ...state,
  ...links
});


const linksReducer = (state = initialState, { type, links }) => ({
  [SET_LINKS]: setLinks
}[type] || (() => state))(state, links);

export default linksReducer;
